import axios from "axios";
import { API_V1 } from "./env";

// DO NOT USE FOR ANY OTHER THING BUT FILE UPLOAD
export const _axiosApi = axios.create({
  baseURL: API_V1,
  withCredentials: true,
});
axios.defaults.withCredentials = true;
